(() => {
  if (customElements.get('kp-wallbed-addons')) return;
  const norm = value => String(value || '').trim().toLowerCase();
  class WallBedAddons extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.parent = JSON.parse(this.querySelector('[data-parent]').textContent);
      this.rows = [...this.querySelectorAll('[data-addon-index]')].map(el => {
        const data = JSON.parse(el.querySelector('[data-addon]').textContent);
        const row = { ...data, el, check: el.querySelector('input'), choices: el.querySelector('.kp-wb-extra__choices'), quantity: 1, selection: {} };
        row.check.addEventListener('change', () => {
          if (row.check.checked && row.rule?.exclusive) this.rows.forEach(other => {
            if (other !== row && other.rule?.exclusive === row.rule.exclusive) other.check.checked = false;
          });
          this.total();
        });
        return row;
      });
      this.dialog = this.querySelector('dialog');
      this.querySelector('[data-choose-extras]')?.addEventListener('click', () => this.dialog.showModal());
      this.querySelectorAll('[data-close-extras]').forEach(b => b.addEventListener('click', () => this.dialog.close()));
      this.querySelectorAll('[data-add-with-extras]').forEach(b => b.addEventListener('click', () => this.addWithExtras()));
      this.change = e => {
        if (this.contains(e.target)) return;
        if (e.target.closest('form, product-info, .m-product-info')) { this.refresh(); this.total(); }
      };
      this.submit = this.onSubmit.bind(this);
      document.addEventListener('change', this.change);
      document.addEventListener('submit', this.submit, true);
      // Minimog updates the hidden variant id without dispatching an input event.
      this.timer = setInterval(() => { if (this.isConnected && document.visibilityState === 'visible') this.refresh(); }, 400);
      this.refresh(); this.hidden = false;
    }
    disconnectedCallback() {
      clearInterval(this.timer); document.removeEventListener('change', this.change); document.removeEventListener('submit', this.submit, true);
      document.body.classList.remove('kp-wb-has-extras'); this.initialized = false;
    }
    form() {
      return [...document.querySelectorAll('form[action*="/cart/add"]')].find(f => this.parent.variants.some(v => String(v.id) === f.querySelector('[name="id"]')?.value));
    }
    variant() {
      const id = this.form()?.querySelector('[name="id"]')?.value;
      return this.parent.variants.find(v => String(v.id) === id);
    }
    money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style:'currency', currency:this.parent.currency || 'GBP' }).format(cents / 100); }
    matchesVariant(row, variant, colour) {
      if (!row?.rule) return false;
      if (!row.rule.match) return true;
      const index = row.options.indexOf(row.rule.match), value = norm(variant.options[index]);
      if (value === norm(colour)) return true;
      if (row.rule.kind === 'shelf' && value === 'grey' && norm(colour) === 'grey matt') return true;
      return row.rule.code === 'CP-12' && value === 'white' && ['white matt','white gloss'].includes(norm(colour));
    }
    refresh() {
      const parent = this.variant();
      if (!parent || parent.id === this.lastId) return;
      this.lastId = parent.id;
      const colourIndex = this.parent.options.findIndex(o => /colou?r/i.test(o));
      const colour = parent.options[colourIndex >= 0 ? colourIndex : 0];
      this.rows.forEach(row => {
        row.compatible = row.variants.filter(v => v.available && this.matchesVariant(row, v, colour));
        row.choices.replaceChildren();
        row.el.classList.toggle('kp-wb-extra--disabled', !row.compatible.length);
        row.el.querySelector('.kp-wb-extra__unavailable').hidden = !!row.compatible.length;
        row.check.disabled = !row.compatible.length;
        if (!row.compatible.length) { row.check.checked = false; row.variant = null; row.el.querySelector('[data-price]').textContent = ''; return; }
        row.options.forEach((name, i) => {
          const values = [...new Set(row.compatible.map(v => v.options[i]))];
          if (name === 'Title' || name === 'Width') return;
          if (values.length === 1) {
            const fixed = document.createElement('span'); fixed.className = 'kp-wb-extra__fixed';
            fixed.textContent = (name === row.rule?.match ? this.parent.strings.match : name) + ': ' + values[0];
            row.choices.append(fixed); return;
          }
          const label = document.createElement('label'); label.textContent = name === row.rule?.match ? this.parent.strings.match : name;
          const select = document.createElement('select'); select.dataset.optionIndex = i;
          select.id = `${row.check.id}-option-${i}`; label.htmlFor = select.id;
          values.forEach(value => select.add(new Option(value, value)));
          if (values.includes(row.selection[i])) select.value = row.selection[i];
          select.disabled = values.length === 1;
          select.addEventListener('change', () => { row.selection[i] = select.value; this.select(row); });
          label.append(select); row.choices.append(label);
        });
        if (row.rule?.max > 1) {
          const label = document.createElement('label'); label.className = 'kp-wb-qty'; label.textContent = this.parent.strings.quantity;
          const select = document.createElement('select');
          select.id = `${row.check.id}-quantity`; label.htmlFor = select.id;
          for (let i=1;i<=row.rule.max;i++) select.add(new Option(String(i),String(i)));
          select.value = row.quantity; select.addEventListener('change',()=>{row.quantity = Number(select.value); this.total();});
          label.append(select); row.choices.append(label);
        }
        this.select(row);
      });
      this.total();
    }
    select(row) {
      const selectors = [...row.choices.querySelectorAll('[data-option-index]')];
      row.variant = row.compatible.find(v => selectors.every(s => v.options[Number(s.dataset.optionIndex)] === s.value));
      row.check.disabled = !row.variant;
      if (!row.variant) row.check.checked = false;
      row.el.querySelector('[data-price]').textContent = row.variant ? '+ ' + this.money(row.variant.price) : '';
      const src = row.rule.images?.[row.variant?.sku];
      if (src) { const img=row.el.querySelector('img'); img.src=src+(src.includes('?')?'&':'?')+'width=160'; img.alt=row.rule.title+' — '+row.variant.options.filter(v=>v!=='Default Title').join(' / '); }
      this.total();
    }
    selected() { return this.rows.filter(r => r.check.checked && r.variant && !r.check.disabled); }
    total() {
      const rows=this.selected();
      this.querySelector('[data-extras-total]').textContent=this.money(rows.reduce((n,r)=>n+r.variant.price*r.quantity,0));
      document.body.classList.toggle('kp-wb-has-extras', rows.length > 0);
      const summary=this.querySelector('[data-selection-summary]');
      if(summary) summary.textContent=rows.length ? rows.map(r=>r.rule.title+(r.quantity>1?' × '+r.quantity:'')).join(' · ') : 'No extras selected';
      // The choose button must show the choice, not the catalogue size, once extras are picked.
      const choose=this.querySelector('[data-choose-extras]');
      if(choose){
        choose.toggleAttribute('data-selected', rows.length > 0);
        choose.querySelector('[data-choose-label]').textContent=rows.length ? 'Your extras' : 'Choose extras';
        choose.querySelector('[data-choose-meta]').textContent=rows.length ? rows.length+' selected · Edit' : this.rows.length+' available';
      }
      const bed=this.variant(), qty=Math.max(1,parseInt(this.form()?.querySelector('[name="quantity"]')?.value || '1',10));
      const extras=rows.reduce((n,r)=>n+r.variant.price*r.quantity,0);
      this.syncStickyTotal(bed, extras, qty);
      const label=rows.length && bed ? 'Add bed + '+rows.length+' extra'+(rows.length>1?'s':'')+' to basket · '+this.money((bed.price+extras)*qty) : '';
      this.querySelectorAll('[data-add-with-extras]').forEach(b=>{ b.hidden=!label || !bed.available; b.textContent=label; });
    }
    syncStickyTotal(bed, extras, quantity) {
      const select=document.querySelector('sticky-atc select[name="id"]');
      if (!select) return;
      // Preserve native labels for every other variant and when extras are removed.
      [...select.options].forEach(option => {
        if (option.dataset.kpWallbedLabel !== undefined) option.textContent=option.dataset.kpWallbedLabel;
      });
      if (!bed || !extras) return;
      const option=[...select.options].find(option => option.value === String(bed.id));
      if (!option) return;
      if (option.dataset.kpWallbedLabel === undefined) option.dataset.kpWallbedLabel=option.textContent;
      // Put the complete amount first so it remains readable in the compact bar.
      option.textContent=this.money((bed.price+extras)*quantity)+' with extras · '+bed.title;
    }
    addWithExtras() {
      const form=this.form(); if(!form) return;
      const button=form.querySelector('button[name="add"], [type="submit"]');
      if(button?.disabled) return;
      if(this.dialog?.open) this.dialog.close();
      form.requestSubmit(button || undefined);
    }
    async onSubmit(e) {
      const form=e.target;
      if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) return;
      const fd=new FormData(form), id=Number(fd.get('id'));
      if (!this.parent.variants.some(v=>v.id===id)) return;
      this.refresh();
      const selected=this.selected(); if (!selected.length) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (this.busy) return;
      this.busy=true;
      const error=this.querySelector('[role="alert"]'); error.hidden=true;
      const button=e.submitter; if(button) button.disabled=true;
      this.setAttribute('aria-busy','true');
      const quantity=Math.max(1,parseInt(fd.get('quantity') || '1',10));
      const properties={}; for(const [key,value] of fd.entries()) { const m=key.match(/^properties\[(.+)\]$/); if(m) properties[m[1]]=value; }
      const items=[{id,quantity,properties}];
      for(const row of selected) items.push({id:row.variant.id,quantity:quantity*row.quantity,parent_id:id,properties:{'For wall bed':this.parent.model,'Bed finish':this.variant()?.options[0] || '',_kp_wallbed_addon:'true'}});
      try {
        properties._kp_wallbed_configuration=(typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') ? crypto.randomUUID() : 'kp-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
        const res=await fetch((window.Shopify?.routes?.root || '/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const data=await res.json(); if(!res.ok || data.status) throw new Error(data.description || this.parent.strings.error);
        window.location.assign((window.Shopify?.routes?.root || '/')+'cart');
      } catch(err) { error.textContent=err.message || this.parent.strings.error; error.hidden=false; this.busy=false; this.removeAttribute('aria-busy'); if(button) button.disabled=false; }
    }
  }
  customElements.define('kp-wallbed-addons',WallBedAddons);
})();
